import {Grid, styled, Typography} from "@mui/material";
import ApiIcon from "assets/icons/businessInfo/ApiIcon";
import TaxIcon from "assets/icons/businessInfo/TaxIcon";
import EconomicIcon from "assets/icons/businessInfo/EconomicIcon";
import {CalendarInput, CheckboxInput, RadioInput, TextInput} from "components/Input/FormControl";
import {InfoContainer, TitleContainer} from "./components";
import {useFormikContext} from "formik";
import warehouseAccountingSystem from "assets/js/warehouseAccountingSystem";
import warehouseAnalyzeSystem from "assets/js/warehouseAnalyzeSystem";
import {useSelector} from "react-redux";
import ValueAddedTaxInput from "components/Input/ValueAddedTaxInput";
import {useEffect} from "react";
import Select from "react-select";

const customSelectStyles = {
    control: (provided: any, state: any) => ({
        ...provided,
        minHeight: 30,
        height: 40,
        borderColor: "#c5c5c5",
        borderRadius: 6,
        marginTop: 2,
        marginBottom: 2,
        fontSize: 12,
    }),
    valueContainer: (provided: any, state: any) => ({...provided}),
    option: (provided: any, state: any) => ({...provided, fontSize: 12}),
};

const MainContainer = styled("div")(({theme}) => ({
    display: "flex",
    flexDirection: "column",
}));

const RadioOption = [
    {
        value: false,
        label: "هجری شمسی",
    },
    {
        value: true,
        label: "میلادی",
    },
];

const AccountingInfo = () => {
    const formikContext = useFormikContext();

    const {values}: { values: any } = formikContext;

    const store = useSelector((state: any) => state);
    const currencies = useSelector((state: any) => state.currencyReducer.currencies);
    const businessCurrencies = store?.businessReducer?.business?.business?.Currencies?.map((x: any) => ({
        label: x.fa_title,
        value: x.id,
    }));

    useEffect(() => {
        if (values.Currencies && values.Currencies.length > 0) {
            formikContext.setFieldValue("multipleCurrency", 1);
        }
    }, []);
    return (
        <MainContainer>
            <InfoContainer>
                <TitleContainer>
                    <ApiIcon/>
                    <Typography sx={{marginRight: "10px"}} variant="body1">
                        امکانات حسابداری
                    </Typography>
                </TitleContainer>
                <TitleContainer secondaryTitle={true}>
                    <CheckboxInput
                        disabled={true}
                        checked={!!warehouseAccountingSystem}
                        name="warehouseSystem"
                        label="سیستم انبارداری"
                    />
                </TitleContainer>
                <Grid sx={{marginBottom: "40px"}} container spacing={4}>
                    <Grid item xs={6}>
                        <div className="font-bold mb-2">سیستم حسابداری انبار</div>
                        <Select
                            styles={customSelectStyles}
                            isRtl={true}
                            isMulti={false}
                            value={warehouseAccountingSystem}
                            isDisabled
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <div className="font-bold mb-2">روش ارزش یابی انبار</div>
                        <Select
                            styles={customSelectStyles}
                            isRtl={true}
                            isMulti={false}
                            value={warehouseAnalyzeSystem}
                            isDisabled
                        />
                    </Grid>
                </Grid>
                <TitleContainer secondaryTitle={true}>
                    <CheckboxInput
                        disabled={true}
                        checked={businessCurrencies}
                        name="multipleCurrency"
                        label="سیستم چند ارزی"
                    />
                </TitleContainer>
                <Grid sx={{marginBottom: "40px", alignItems: "end"}} container spacing={4}>
                    <Grid item xs={6}>
                        <div className="font-bold mb-2">واحد پول اصلی</div>
                        <Select
                            styles={customSelectStyles}
                            isRtl={true}
                            isMulti={false}
                            value={currencies[0]}
                            isDisabled
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <div className="font-bold mb-2">سایر ارزها</div>
                        <Select
                            styles={customSelectStyles}
                            isRtl={true}
                            isMulti={true}
                            value={businessCurrencies}
                            isDisabled
                        />
                    </Grid>
                </Grid>
                <TitleContainer>
                    <TaxIcon/>
                    <Typography sx={{marginRight: "10px"}} variant="body1">
                        مالیات برارزش افزوده
                    </Typography>
                </TitleContainer>
                <Grid sx={{marginBottom: "40px"}} container spacing={4}>
                    <Grid item xs={6}>
                        {/* <TextInput required={true} name='title' label="عنوان" /> */}
                        <ValueAddedTaxInput/>
                    </Grid>
                    <Grid item xs={6}>
                        <RadioInput disabled={true} name="is_gregorian" radioOption={RadioOption} label="نقویم"/>
                    </Grid>
                </Grid>
                <TitleContainer>
                    <EconomicIcon/>
                    <Typography sx={{marginRight: "10px"}} variant="body1">
                        اطلاعات سال مالی
                    </Typography>
                </TitleContainer>
                <Grid sx={{marginBottom: "40px"}} container spacing={4}>
                    <Grid item xs={12} md={6}>
                        <TextInput disabled={true} required={true} name="fiscalYearTitle" label=" عنوان سال مالی"/>
                    </Grid>
                    <Grid item xs={6} md={3}>
                        {/* <TextInput required={true} name='title' label="عنوان" /> */}
                        <CalendarInput
                            disabled={true}
                            name="startDate"
                            label="تاریخ شروع"
                            required={true}
                            isGregorian={values?.isGregorian}
                        />
                    </Grid>
                    <Grid item xs={6} md={3}>
                        <CalendarInput
                            disabled={true}
                            name="endDate"
                            label="تاریخ پایان"
                            required={true}
                            isGregorian={values?.isGregorian}
                        />
                    </Grid>
                </Grid>
            </InfoContainer>
        </MainContainer>
    );
};

export default AccountingInfo;
